import React from 'react'
import LoginContainer from './LoginContainer'

const Login = (props) => (
  <LoginContainer location={props.location.pathname}/>
)

export default Login



// WEBPACK FOOTER //
// src/routes/Login/index.js